// @ts-nocheck
import { compose, withState, withHandlers } from "recompose"

export const withToggle = compose(
  withState("show", "toggleShow", false),
  withHandlers({
    toggle: props => () => props.toggleShow(x => !x),
  }),
)
